import React from 'react'

import { useIcaewModals } from '../hooks/useIcaewModals'

const IcaewModalSteps: React.FC = () => {
  const { currentStepNumber, numSteps, shouldShowStepIndicators } =
    useIcaewModals()

  if (!shouldShowStepIndicators) {
    return null
  }

  return (
    <span className="text-muted d-inline-block ms-2 fw-normal text-base">
      ({currentStepNumber}/{numSteps})
    </span>
  )
}

export default IcaewModalSteps
